export default __webpack_public_path__ + "static/media/forms-bg.c5b68a63.png";